module.exports = __webpack_public_path__ + "media/svg/so-235bc705.svg";